var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import * as React from "react";
import { memo, useCallback, useEffect, useMemo, useRef } from "react";
import { MovieItemView } from "../movie/MovieItemView";
import "./movieBlockViewStyles.css";
import { useRouter } from "../../../context/Router";
import { SeeMoreItemView } from "../movie/SeeMoreItemView";
import { BlockItemCard } from "./BlockItemCard";
import { focusManager } from "../../../utils/Focus";
export var MovieBlockView = memo(function (_a) {
    var slug = _a.slug, title = _a.title, movies = _a.movies, onMoviePress = _a.onMoviePress, block = _a.block, _b = _a.active, active = _b === void 0 ? true : _b;
    var navigate = useRouter().navigate;
    var containerRef = useRef(null);
    useEffect(function () {
        if (containerRef.current) {
            focusManager.registerGroup({
                name: slug,
                horizontalContainer: containerRef.current,
            });
        }
    }, [slug]);
    var items = useMemo(function () {
        var _a;
        var blockItems = (_a = block === null || block === void 0 ? void 0 : block.blockItems) !== null && _a !== void 0 ? _a : [];
        var blockItemPositions = new Set(blockItems.map(function (b) { return b.position; }));
        var merged = [];
        for (var _i = 0, blockItems_1 = blockItems; _i < blockItems_1.length; _i++) {
            var blockItem = blockItems_1[_i];
            merged.push({
                position: blockItem.position,
                item: __assign(__assign({}, blockItem), { isBlock: true }),
            });
        }
        var movieIndex = 0;
        for (var position = 0; movieIndex < movies.length; position++) {
            if (blockItemPositions.has(position))
                continue;
            merged.push({
                position: position,
                item: movies[movieIndex],
            });
            movieIndex++;
        }
        var sorted = merged
            .sort(function (a, b) { return a.position - b.position; })
            .map(function (m) { return m.item; });
        var result = sorted.slice(0, 10);
        var finalItems = result.slice(0, 10);
        var isBlocksType = (block === null || block === void 0 ? void 0 : block.blockType) === "blocks";
        if (isBlocksType) {
            return finalItems;
        }
        return __spreadArrays(finalItems, [{ id: "see_more-" + slug, seeMore: true }]);
    }, [movies, block, slug]);
    var renderItem = useCallback(function (item, i) {
        if ("seeMore" in item && item.seeMore) {
            return (React.createElement(SeeMoreItemView, { key: item.id, onPress: function () { return navigate("see-more", { slug: slug }); }, focusRaw: [slug, i] }));
        }
        if ("isBlock" in item && item.isBlock) {
            return (React.createElement(BlockItemCard, { key: "block-" + item.targetSlug + "-" + i, item: item, focusRaw: [slug, i], active: active }));
        }
        return (React.createElement(MovieItemView, { key: item.id, movie: item, focusRaw: [slug, i], active: active, onMoviePress: onMoviePress }));
    }, [slug, onMoviePress, active]);
    return (React.createElement("div", { className: "block-container" },
        React.createElement("h2", null, title),
        React.createElement("div", { ref: containerRef, id: slug, className: "block-movies-container" }, items.length > 0
            ? items.map(function (block, index) { return renderItem(block, index); })
            : null)));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/block/MovieBlockView.tsx
// module id = 114
// module chunks = 1